<template>
  <div>
    <div id="spinner-loading-wrapper">
      <div id="loading-text">LOADING</div>
      <div id="loading-content"></div>
    </div>
  </div>
</template>

<script>
import { preloadData } from "@/data/preloadData";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "SiteLoader",
  data() {
    return {
      preloadDataStatus: false,
      userInfoStatus: false,
    };
  },
  created() {
    setTimeout(() => {
      this.preloadDataStatus = true;
      //if (location.pathname.split("/").pop() == "") {
      this.$emit("setLoaderFinished", true);
      //}
    }, 750);
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    ...mapState(["userInfo"]),
    allStatus() {
      return this.preloadDataStatus && this.userInfoStatus;
    },
  },
  watch: {
    allStatus(newStatus, oldStatus) {
      if (newStatus) {
        this.$emit("setLoaderFinished", true);
      }
    },
  },
  mounted() {
    this.$store.watch(
      (state, getters) => getters.getUserInfo,
      (newValue) => {
        if (
          typeof newValue !== "undefined" &&
          typeof newValue.userStatus !== "undefined"
        ) {
          this.userInfoStatus = true;
        }
      }
    );
  },
};
</script>

<style lang="scss" scoped>
$color1: #ffd300;
$color2: white;
$color3: #ffd300;
$fontColor: white;
$backgroundColor: #00285e;
$primary-color-dark: #00285e;

#spinner-loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: $backgroundColor;
  z-index: 9999;

  #loading-text {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    color: $fontColor;
    width: 100px;
    height: 30px;
    margin: -7px 0 0 -45px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
  }

  #loading-content {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 170px;
    height: 170px;
    margin: -85px 0 0 -85px;
    border: 3px solid #f00;
  }

  #loading-content:after {
    content: "";
    position: absolute;
    border: 3px solid #0f0;
    left: 15px;
    right: 15px;
    top: 15px;
    bottom: 15px;
  }

  #loading-content:before {
    content: "";
    position: absolute;
    border: 3px solid #00f;
    left: 5px;
    right: 5px;
    top: 5px;
    bottom: 5px;
  }

  #loading-content {
    border: 3px solid transparent;
    border-top-color: $color3;
    border-bottom-color: $color3;
    border-radius: 50%;
    animation: loader 2s linear infinite;
  }

  #loading-content:before {
    border: 3px solid transparent;
    border-top-color: $color2;
    border-bottom-color: $color2;
    border-radius: 50%;
    animation: loader 3s linear infinite;
  }

  #loading-content:after {
    border: 3px solid transparent;
    border-top-color: $color1;
    border-bottom-color: $color1;
    border-radius: 50%;
    animation: loader 3s linear infinite;
  }

  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>